import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Clock, Heart, Users, CheckCircle2, ShieldCheck } from "lucide-react";

function Counter({ value, testid }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    let started = false;
    const run = () => {
      if (started) return;
      started = true;
      const t0 = performance.now();
      const dur = 1200;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const obs = new IntersectionObserver((es) => es.some((e) => e.isIntersecting) && run(), { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref} data-testid={testid} className="text-4xl sm:text-5xl font-display font-bold text-white tabular-nums">{n.toLocaleString()}</span>;
}

export default function ImpactWall() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/impact").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const items = [
    [Clock, d.hours_of_help, "hours of help given", "impact-hours"],
    [CheckCircle2, d.visits_completed, "visits completed", "impact-visits"],
    [Heart, d.thank_you_cards, "thank-you cards sent", "impact-thanks"],
    [Users, d.neighbours_connected, "neighbours connected", "impact-neighbours"],
    [ShieldCheck, d.verified_helpers, "verified helpers", "impact-verified"],
  ];
  return (
    <section data-testid="impact-wall" className="bg-[#2E7D6B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        <p className="text-sm font-semibold uppercase tracking-wider text-white/70">Kindred in numbers</p>
        <h2 className="text-2xl sm:text-3xl font-display font-bold mt-1 mb-8">Small kindnesses, adding up</h2>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-6">
          {items.map(([Icon, v, label, testid]) => (
            <div key={label} className="bg-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <Icon className="w-7 h-7 text-[#F3C9B1]" />
              <div className="mt-3"><Counter value={v} testid={testid} /></div>
              <p className="text-white/85 mt-1">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
